import BaseBoilerplatePromoModal from 'src/components/Promotions/BaseBoilerplatePromoModal.svelte';
import { PROMOTIONS } from 'src/constants';
import type { ModalConfig } from 'src/types/Modals';
import { format } from 'svelte-i18n';
import { get } from 'svelte/store';

export const SmartHomeChallengeModalConfig = (): ModalConfig => ({
	id: 'smartHomeChallenge',
	component: BaseBoilerplatePromoModal,
	props: {
		showModal: true,
		urlPath:
			'pages/shelly-smart-home-challenge-2025?utm_source=app&utm_medium=app&utm_campaign=challenge-25',
		imageUrl: './images/smart-home-challenge.png',
		modalTitle: get(format)('modal_title_smart_home_challenge'),
		heading: get(format)('title_smart_home_challenge'),
		subHeading: get(format)('subtitle_smart_home_challenge'),
		text: get(format)('sentence_smart_home_challenge_1'),
		dateSentence: get(format)('sentence_smart_home_challenge_2', {
			values: {
				datePrimarySpan: `<span class="text-primary">${get(format)('dates_smart_home_challenge')}</span>`,
			},
		}),
		buttonText: get(format)('button_submit_now'),
	},
	rules: [
		{
			check: () => {
				const now = new Date().getTime();
				return (
					now >= PROMOTIONS.SMART_HOME_CHALLENGE.START_DATE &&
					now < PROMOTIONS.SMART_HOME_CHALLENGE.END_DATE
				);
			},
			expected: true,
		},
	],
});
